import React, { createContext, useContext, useState } from 'react';

const translations = {
  az: {
    home: 'ANA SƏHIFƏ',
    products: 'MƏHSULLAR',
    about: 'HAQQIMIZDA',
    delivery: 'ÇATDIRILMA',
    contact: 'ƏLAQƏ',
    blog: 'BLOQ',
    whatsapp: 'WHATSAPP',
    cart: 'Səbət',
    addToCart: 'Səbətə Əlavə Et',
    orderViaWhatsApp: 'WhatsApp ilə Sifariş Et',
    inStock: 'STOKDA',
    size: 'Ölçü',
    quantity: 'Miqdar',
    total: 'Cəmi',
    customerInfo: 'Çatdırılma Məlumatları',
    name: 'Ad Soyad',
    phone: 'Telefon',
    address: 'Çatdırılma ünvanı',
    back: 'Geri',
    newOrder: 'Yeni Sifariş',
    customerDetails: 'Müştəri Məlumatları',
    search: 'Axtar',
    filter: 'Filter',
    allProducts: 'BÜTÜN MƏHSULLAR',
    showMore: 'Daha çox göstər',
    showLess: 'Daha az göstər',
    noProducts: 'Məhsul tapılmadı',
    description: 'Təsvir',
    wishlist: 'Sevimlilər',
    addToWishlist: 'Sevimlilərə əlavə et',
    removeFromWishlist: 'Sevimlilərdən sil'
  },
  en: {
    home: 'HOME',
    products: 'PRODUCTS',
    about: 'ABOUT',
    delivery: 'DELIVERY',
    contact: 'CONTACT',
    blog: 'BLOG',
    whatsapp: 'WHATSAPP',
    cart: 'Cart',
    addToCart: 'Add to Cart',
    orderViaWhatsApp: 'Order via WhatsApp',
    inStock: 'IN STOCK',
    size: 'Size',
    quantity: 'Quantity',
    total: 'Total',
    customerInfo: 'Delivery Information',
    name: 'Full Name',
    phone: 'Phone',
    address: 'Delivery Address',
    back: 'Back',
    newOrder: 'New Order',
    customerDetails: 'Customer Details',
    search: 'Search',
    filter: 'Filter',
    allProducts: 'ALL PRODUCTS',
    showMore: 'Show more',
    showLess: 'Show less',
    noProducts: 'No products found',
    description: 'Description',
    wishlist: 'Wishlist',
    addToWishlist: 'Add to wishlist',
    removeFromWishlist: 'Remove from wishlist'
  },
  ru: {
    home: 'ГЛАВНАЯ',
    products: 'ПРОДУКТЫ',
    about: 'О НАС',
    delivery: 'ДОСТАВКА',
    contact: 'КОНТАКТ',
    blog: 'БЛОГ',
    whatsapp: 'WHATSAPP',
    cart: 'Корзина',
    addToCart: 'Добавить в корзину',
    orderViaWhatsApp: 'Заказать через WhatsApp',
    inStock: 'В НАЛИЧИИ',
    size: 'Размер',
    quantity: 'Количество',
    total: 'Итого',
    customerInfo: 'Информация о доставке',
    name: 'Полное имя',
    phone: 'Телефон',
    address: 'Адрес доставки',
    back: 'Назад',
    newOrder: 'Новый заказ',
    customerDetails: 'Данные клиента',
    search: 'Поиск',
    filter: 'Фильтр',
    allProducts: 'ВСЕ ПРОДУКТЫ',
    showMore: 'Показать больше',
    showLess: 'Показать меньше',
    noProducts: 'Товары не найдены',
    description: 'Описание',
    wishlist: 'Избранное',
    addToWishlist: 'Добавить в избранное',
    removeFromWishlist: 'Удалить из избранного'
  },
  tr: {
    home: 'ANA SAYFA',
    products: 'ÜRÜNLER',
    about: 'HAKKIMIZDA',
    delivery: 'TESLİMAT',
    contact: 'İLETİŞİM',
    blog: 'BLOG',
    whatsapp: 'WHATSAPP',
    cart: 'Sepet',
    addToCart: 'Sepete Ekle',
    orderViaWhatsApp: 'WhatsApp ile Sipariş Ver',
    inStock: 'STOKTA',
    size: 'Beden',
    quantity: 'Adet',
    total: 'Toplam',
    customerInfo: 'Teslimat Bilgileri',
    name: 'Ad Soyad',
    phone: 'Telefon',
    address: 'Teslimat Adresi',
    back: 'Geri',
    newOrder: 'Yeni Sipariş',
    customerDetails: 'Müşteri Bilgileri',
    search: 'Ara',
    filter: 'Filtre',
    allProducts: 'TÜM ÜRÜNLER',
    showMore: 'Daha fazla göster',
    showLess: 'Daha az göster',
    noProducts: 'Ürün bulunamadı',
    description: 'Açıklama',
    wishlist: 'Favoriler',
    addToWishlist: 'Favorilere ekle',
    removeFromWishlist: 'Favorilerden kaldır'
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('az');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};